export default __webpack_public_path__ + "static/media/1daya logo.123379a2.png";